import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ViewModule} from "./view/view.module";
import {ServiceModule} from "./service/service.module";

@NgModule({
  imports: [
    CommonModule,
    ServiceModule,
    ViewModule,
  ],
  declarations: [],
  exports: [ServiceModule, ViewModule]
})
export class BingMapsModule {

}
